// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Table.module.css';
import DropDown from './StatusDropDown/DropDown';
const CompletedIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
)

export default function TableRow({ value, index }) {

  return (
    <>
      {/* Desktop view */}
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <h5>{value.name}</h5>
        </div>
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          {/* <h5>{value.risk}</h5> */}
          <DropDown
            selectedValue={value.risk}
            isDropDown={false}
          />
        </div>
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <h5>{value.Info}</h5>
        </div>
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <div className='flexAlign10' >
            <CompletedIcon
              width="14px"
              height="14px"
              fill={'#006b32'}
            />
            <h5>{value.status}</h5>
          </div>
        </div>
      </div>
    </>
  );
}
